export const ClassCode = {
	Glamper: "M",
	Trailer: "T",
	Mystery: "X",
};
